import { ReactElement, ReactNode } from "react";
import { Container } from "./styles";
import { Row } from "react-bootstrap";

export const MainContainer = ({
  children,
}: {
  children: ReactNode;
}): ReactElement => {
  return (
    <Container>
      <Row className="g-1">{children}</Row>
    </Container>
  );
};
